import { useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const OPTIONS = [["helped", "Helped"], ["little", "A little"], ["not", "Not really"]];
const THANKS = { helped: "Lovely. Added to your playbook 💜", little: "Thanks, every bit counts 💜", not: "Thanks for saying. Your playbook will learn from that 💜" };

// One-tap, optional "Did that help?" that feeds the What Helps Me playbook
export const HelpRating = ({ kind, toolId, toolName, dark = false, className = "" }) => {
  const [done, setDone] = useState(null);
  const rate = (rating) => {
    setDone(rating);
    api.post("/playbook/rating", { kind, tool_id: toolId || undefined, tool_name: toolName || undefined, rating }).catch((e) => logError("Help rating failed:", e));
  };
  const chip = dark ? "bg-white/15 text-white hover:bg-white/25" : "bg-mm-primary/10 text-mm-primary hover:bg-mm-primary/20";
  if (done) return <p className={`text-sm mm-fade-up ${dark ? "text-white/80" : "text-mm-muted"} ${className}`} role="status" data-testid="help-rating-thanks">{THANKS[done]}</p>;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="help-rating">
      <span className={`text-sm font-semibold ${dark ? "text-white/80" : ""}`}>Did that help?</span>
      {OPTIONS.map(([k, l]) => <button key={k} type="button" onClick={() => rate(k)} className={`rounded-full px-3 py-1.5 text-sm font-semibold transition-colors ${chip}`} data-testid={`help-rating-${k}`}>{l}</button>)}
    </div>
  );
};
